( function( $ ) {

var pageId = 'page-invite',
    page = '#' + pageId;

$( function() {
    $('body')
    .on('click', page + ' .select-all-proj', function(e) {
        e.preventDefault();
        $('.proj-in input[type=checkbox]').prop('checked', true);
    })
    .on('click', page + ' .select-none-proj', function(e) {
        e.preventDefault();
        $('.proj-in input[type=checkbox]').prop('checked', false);
    })
    .on('click', page + ' .select-all-cal', function(e) {
        e.preventDefault();
        $('.cal-in input[type=checkbox]').prop('checked', true);
    })
    .on('click', page + ' .select-none-cal', function(e) {
        e.preventDefault();
        $('.cal-in input[type=checkbox]').prop('checked', false);
    })
    .on('click', page + ' .select-all-projects', function(e) {
        e.preventDefault();
        $('tr-project-checkboxes').get(0).selectAll();
    })
    .on('click', page + ' .unselect-all-projects', function(e) {
        e.preventDefault();
        $('tr-project-checkboxes').get(0).unselectAll();
    })
    .on('change', page + ' .proj-in .welcome input[type=checkbox]', function(e) {
        var target = $(this);

        if (target.is(':checked')) {
            return
        }

        simple.dialog.confirm({
            content: "勾选「熟悉Tower」项目可以让新成员快速了解 Tower 的使用，你确定要不勾选「熟悉Tower」项目吗？",
            callback: function(e, yes) {
                if (!yes) {
                    target.prop('checked', true);
                }
            }
        });
    })
    .on('click', page + ' .form-invite .view-mail', function(e) {
        var emails = {},
            roles = {};

        $('.invite-item').each(function(index) {
            var it = $(this),
                email = $.trim(it.find('input.invite-email').val()),
                role = it.find('select.invite-role').val();

            if (email) {
                emails[index] = email;
                roles[index] = role;
            }
        });

        var invites = {
            emails: JSON.stringify(emails),
            init_roles: JSON.stringify(roles),
            projects: $('.proj-in input[type=checkbox]:checked').map(function() {
                                    return this.value;
                                }).get(),
            calendars: $('.cal-in input[type=checkbox]:checked').map(function() {
                                    return this.value;
                                }).get(),
            invite_mail: $('#txt-welcome').val()
        }

        simple.util.storage.set('invites', JSON.stringify(invites));
    })
    .on('click', page + ' .form-invite .btn-x', function(e) {
        simple.util.storage.remove('invites');
    });
});

function loadInvites(page) {
    var invites = simple.util.storage.get('invites');
    if (invites) {
        invites = JSON.parse(invites);
        var emails = JSON.parse(invites.emails);
        var inviteCount = Object.keys(emails).length;

        page.find('.proj-in input, .cal-in input').prop('checked', false);

        for (; inviteCount > 2; inviteCount--) {
            page.find('#add-invite-item').trigger('click');
        }

        $.each(emails, function(index, email) {
            $(page.find('.invite-email')[index]).val(email);
        });

        $.each(JSON.parse(invites.init_roles), function(index, role) {
            $(page.find('.invite-role')[index]).val(role);
        });

        $.each(invites.projects, function(index, guid) {
            page.find('.proj-in input[value=' + guid + ']').prop('checked', true);
        });

        $.each(invites.calendars, function(index, guid) {
            page.find('.cal-in input[value=' + guid + ']').prop('checked', true);
        });

        $('#txt-welcome').val(invites.invite_mail);
    }
}

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    loadInvites($page);
});


})( jQuery );
